import classNames from "classnames"
import React from "react";
import { root, two, three, four, five, contentList, functionStyle, footer, gap_s, gap_m, gap_l, s, m, l } from "./grid.module.scss";

interface Props {
  className?: string
  id?: string
  title?: React.ReactNode
  lead?: React.ReactNode
  column?: "two" | "three" | "four" | "five" | "contentList"
  use?: "function" | "footer"
  children: React.ReactNode
  gridGap?: "gap_s" | "gap_m" | "gap_l"
  margin?: "s" | "m" | "l"
}

export default React.memo((props: Props) => {
  const { className, id, children, column, use, gridGap, margin } = props
  const classes = classNames(
    root,
    {
      [two]: column === "two",
      [three]: column === "three",
      [four]: column === "four",
      [five]: column === "five",
      [contentList]: column === "contentList",
      [functionStyle]: use === "function",
      [footer]: use === "footer",
      [gap_s]: gridGap === "gap_s",
      [gap_m]: gridGap === "gap_m",
      [gap_l]: gridGap === "gap_l",
      [s]: margin === "s",
      [m]: margin === "m",
      [l]: margin === "l",
    },
    className
  )

  return (
    <div id={id} className={classes}>
      {children}
    </div>
  )
})
